import * as React from "react";

import { cn } from "../../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Design-system tokens (the shadcn --background/--input/--ring vars
          // are not defined in tailwind.config, which left inputs with no
          // background, border, or text color — invisible typing).
          "flex h-10 w-full rounded-lg border border-border bg-surface1 px-3 py-2 text-sm text-text",
          "placeholder:text-muted transition-colors",
          "hover:border-border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:border-brand/50",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
